/**
 * @desc 通过包裹单号获取信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrderContract.detail.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderContract/detail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
